import isChromatic from 'chromatic/isChromatic'

/**
 * Returns SVG filter for drop shadow. Can be reused in other SVGs.
 *
 * Note:
 * The `id` must be unique per rendered instance. `AccessibleSVG` generates one
 * with `useId()` and exposes the ready `filter` value to its children via a
 * render-prop, so prefer consuming that instead of referencing the id directly.
 */
export const ShadowFilter: React.FC<
  { id: string } & React.SVGProps<SVGFEDropShadowElement>
> = ({ id, ...props }) => {
  const noop = isChromatic()
  return (
    <filter id={id} colorInterpolationFilters="sRGB">
      {noop ? (
        <feDropShadow
          dx="0"
          dy="0"
          stdDeviation="0"
          floodColor="transparent"
          floodOpacity="0"
        />
      ) : (
        <feDropShadow
          dx="0"
          dy="0"
          stdDeviation="1"
          floodColor="black"
          floodOpacity="0.35"
          {...props}
        />
      )}
    </filter>
  )
}
